import type { TargetDefinition } from '@/types/webflash';

/**
 * STM32G071RB — Cortex-M0+, 128 KB flash, 36 KB SRAM, no hardware CRC
 */
export const STM32G0: TargetDefinition = {
  name: 'STM32G071RB',
  partNumber: 'STM32G071RB',
  idcodes: [0x0BC11477], // Cortex-M0+ SWD IDCODE
  cpuType: 'CM0+',
  flashBase: 0x08000000,
  flashSize: 128 * 1024,  // 128 KB
  ramBase: 0x20000000,
  ramSize: 36 * 1024,     // 36 KB
  hasHardwareCRC: false,
  sectors: (() => {
    // STM32G0: uniform 2 KB pages
    const sectors = [];
    for (let i = 0; i < 64; i++) {
      sectors.push({ address: 0x08000000 + i * 2048, size: 2048 });
    }
    return sectors;
  })(),
};
